module.exports = __webpack_public_path__ + "img/t1-10.2dcbb2bf.png";